import styled from 'styled-components';
import { accent, symbol, secondary, white, gray, lightGray } from '~/components/mixins/color';

export const Container = styled.div`
  height: calc(100% - 20px);
  margin: 10px;
  background: ${white.hex()};
  border-radius: 6px;
  overflow: hidden;
`;

export const Row = styled.div`
  display: grid;
  grid-column-gap: 10px;
  grid-template-columns: repeat(${(props) => props.span || 1}, 1fr);
  width: 100%;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  background: ${white.hex()};
  align-items: center;
  border-radius: 6px;

  & > img {
    width: 190px;
    margin: 10px;
  }
`;

export const HeaderData = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  justify-content: center;
  width: 100%;
`;

export const Employees = styled.div`
  height: calc(100% - 190px);
  overflow-y: scroll;
  overflow-x: hidden;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const Employee = styled.div`
  display: flex;
  padding: 5px 10px;
  background: ${secondary.hex()};
  border-radius: 6px;
  align-items: center;
  margin: 0px 10px 10px;

  > .avatar {
    width: 50px;
    height: 50px;
    margin: 5px auto;
    overflow: hidden;
    border-radius:50%;
    position: relative;

    & > img {
      position: absolute;
      top:50%;
      left:50%;
      max-height: 50px;
      max-width: 50px;
      transform: translate(-50%,-50%)
    }
  }

  & > div {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 5px 10px;

    .info {
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;

      .checks span {
        color: ${symbol.hex()};
        font-size: 12px;
      }
    }

    .subInfo {
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;

      span {
        color: ${lightGray.hex()};
        line-height: 20px;
      }

      div {
        font-size: 12px;
        color: ${gray.hex()};
      }
    }
  }
`;

export const InputItem = styled.div`
  display: grid;
  position: relative;
  margin: 0 0 10px;
  width: 100%;

  & > svg {
    position: absolute;
    right: 15px;
    align-self: center;
    color: ${gray.hex()};
    transition: color 0.2s ease 0s;
  }

  & > svg:hover {
    color: ${accent.hex()};
    cursor: pointer;
  }

  &:focus-within > input {
    border-color: ${accent.hex()};
  }

  &:focus-within > svg {
    color: ${accent.hex()};
  }

  input {
    background: ${secondary.hex()};
    border: 2px solid ${secondary.hex()};
    border-radius: 3px;
    padding: 19px 40px 8px 10px;
    color: ${gray.hex()};
    position: relative;
    transition: border-color 0.2s ease-in 0s;

    &:disabled {
      opacity: 0.75;
    }

    &::placeholder {
      color: transparent;
    }

    &:focus + label,
    &:not(:placeholder-shown) + label {
      font-size: 70%;
      transform: translate3d(0, -100%, 0);
      opacity: 1;
      top: 20px;
    }

    &:not(:focus):not(:invalid):not(:placeholder-shown) + label {
      font-size: 70%;
      transform: translate3d(0, -100%, 0);
      opacity: 1;
      top: 20px;
    }

    & + label {
      position: absolute;
      top: 15px;
      padding-left: 10px;
      transition: all 200ms;
      opacity: 0.75;
      color: ${gray.hex()};
    }
  }
`;
